<template>
    <client-page class="wrap--mypage">
        <!-- 서브비주얼 -->
        <!-- <sub-visual visual="회원정보수정" /> -->

        <v-container>
            <div class="mypage-container">
                <!-- 네비게이션 메뉴 -->
                <mypage-navigation></mypage-navigation>
                <!-- 페이지 콘텐츠 -->
                <div v-if="me" class="mypage-contents">
                    <div class="tit-wrap tit-wrap--unberline">
                        <h2 class="tit">회원정보수정</h2>
                    </div>
                    <div class="mb-10">
                        <h3 class="tit tit--xs">회원정보</h3>
                    </div>
                    <v-tabs-items :value="tab">
                        <v-tab-item value="view">
                            <v-divider class="primary border-2"></v-divider>
                            <div class="py-20 px-md-10 py-md-36">
                                <div class="mt-n8 mt-md-n14">
                                    <myinfo-row label="아이디"> {{ me.username }} </myinfo-row>

                                    <template v-if="me.type == PERSON.value">
                                        <myinfo-row label="이름">
                                            {{ me.name }}
                                        </myinfo-row>
                                        <myinfo-row label="생년월일">
                                            {{ me.bornAt }}
                                        </myinfo-row>
                                        <myinfo-row label="성별">
                                            {{ me.sex }}
                                        </myinfo-row>
                                        <myinfo-row label="국가">
                                            {{ me.nation }}
                                        </myinfo-row>
                                        <myinfo-row label="직업">
                                            {{ me.occupation }}
                                        </myinfo-row>
                                        <myinfo-row label="직장">
                                            {{ me.companyName }}
                                        </myinfo-row>
                                    </template>
                                    <template v-if="me.type == COMPANY.value">
                                        <myinfo-row label="기업명">
                                            {{ me.name }}
                                        </myinfo-row>
                                        <myinfo-row label="기업설립일">
                                            {{ me.foundAt }}
                                        </myinfo-row>
                                        <myinfo-row label="사업자등록번호">
                                            {{ me.businessRegisitrationNumber }}
                                        </myinfo-row>
                                        <myinfo-row label="국가">
                                            {{ me.nation }}
                                        </myinfo-row>
                                        <myinfo-row label="대표자명">
                                            {{ me.ceoName }}
                                        </myinfo-row>
                                        <myinfo-row label="홈페이지주소">
                                            {{ me.website }}
                                        </myinfo-row>
                                    </template>

                                    <myinfo-row label="연락처"> {{ me.phone1 }} - {{ me.phone2 }} - {{ me.phone3 }} </myinfo-row>

                                    <myinfo-row label="이메일">
                                        {{ me.email }}
                                    </myinfo-row>

                                    <myinfo-row label="주소">
                                        [{{ me.postcode }}]
                                        {{ me.address1 }}
                                        {{ me.address2 }}
                                    </myinfo-row>

                                    <template v-if="me.type == COMPANY.value">
                                        <myinfo-row label="담당자 이름">
                                            {{ me.workerName }}
                                        </myinfo-row>
                                        <myinfo-row label="담당자 이메일">
                                            {{ me.workerEmail }}
                                        </myinfo-row>
                                        <myinfo-row label="연락처"> {{ me.workerPhone1 }} - {{ me.workerPhone2 }} - {{ me.workerPhone3 }} </myinfo-row>
                                    </template>

                                    <myinfo-row label="정보수신방법" v-if="me?.notify">
                                        <v-row v-for="(item, index) in me?.notify" :key="index" v-show="item.enabled" class="row--x-small mt-2">
                                            <v-col cols="auto"><span class="font-weight-medium">{{ getNotifyName(item) }}</span></v-col>
                                            <v-col>{{ item.contact }}</v-col>
                                        </v-row>
                                    </myinfo-row>
                                </div>
                            </div>
                            <v-divider class="grey-cb"></v-divider>

                            <!-- 하단버튼 -->
                            <div class="mt-30 mt-md-50">
                                <div class="v-btn--group v-btn--group--large">
                                    <v-btn x-large color="primary" class="w-100 mw-220px" @click="goModify">수정</v-btn>
                                </div>
                            </div>
                        </v-tab-item>

                        <v-tab-item value="modify">
                            <div class="table-style table-style--default">
                                <myinfo-modify-row label="아이디"> {{ me.username }} </myinfo-modify-row>
                                <myinfo-modify-row label="비밀번호" pointer>
                                    <v-text-field v-model="me.subPassword" type="password" name="password" outlined hide-details class="w-100 mw-lg-500px"></v-text-field>
                                    <small class="text-grey text-grey--right">(영문대소문자/숫자/특수문자 중 2가지 이상 조합, 8 - 16자)</small>
                                </myinfo-modify-row>
                                <myinfo-modify-row label="비밀번호 확인" pointer>
                                    <v-text-field v-model="me.subPassword2" type="password" name="" value="" outlined hide-details class="w-100 mw-lg-500px" placeholder="비밀번호를 재입력하세요." />
                                </myinfo-modify-row>

                                <template v-if="me.type == PERSON.value">
                                    <myinfo-modify-row label="이름">
                                        <v-text-field v-model="me.name" type="text" outlined hide-details class="w-100 mw-lg-500px" />
                                    </myinfo-modify-row>
                                    <myinfo-modify-row label="생년월일">
                                        <v-text-field v-model="me.bornAt" type="date" outlined hide-details class="w-100 mw-lg-500px" />
                                    </myinfo-modify-row>
                                    <myinfo-modify-row label="성별">
                                        <v-text-field v-model="me.sex" type="text" outlined hide-details class="w-100 mw-lg-500px" />
                                    </myinfo-modify-row>
                                    <myinfo-modify-row label="국가">
                                        <v-text-field v-model="me.nation" type="text" outlined hide-details class="w-100 mw-lg-500px" />
                                    </myinfo-modify-row>
                                    <myinfo-modify-row label="직업">
                                        <v-text-field v-model="me.occupation" type="text" outlined hide-details class="w-100 mw-lg-500px" />
                                    </myinfo-modify-row>
                                    <myinfo-modify-row label="직장">
                                        <v-text-field v-model="me.companyName" type="text" outlined hide-details class="w-100 mw-lg-500px" />
                                    </myinfo-modify-row>
                                </template>
                                <template v-if="me.type == COMPANY.value">
                                    <myinfo-modify-row label="기업명" pointer>
                                        <v-text-field v-model="me.name" type="text" outlined hide-details class="w-100 mw-lg-500px" />
                                    </myinfo-modify-row>
                                    <myinfo-modify-row label="기업설립일">
                                        <v-text-field v-model="me.foundAt" type="date" outlined hide-details class="w-100 mw-lg-500px" />
                                    </myinfo-modify-row>
                                    <myinfo-modify-row label="사업자등록번호" pointer>
                                        <v-text-field v-model="me.businessRegisitrationNumber" type="text" outlined hide-details class="w-100 mw-lg-500px" />
                                    </myinfo-modify-row>
                                    <myinfo-modify-row label="국가">
                                        <v-text-field v-model="me.nation" type="text" outlined hide-details class="w-100 mw-lg-500px" />
                                    </myinfo-modify-row>
                                    <myinfo-modify-row label="대표자명">
                                        <v-text-field v-model="me.ceoName" type="text" outlined hide-details class="w-100 mw-lg-500px" />
                                    </myinfo-modify-row>
                                    <myinfo-modify-row label="홈페이지주소">
                                        <v-text-field v-model="me.website" type="text" outlined hide-details class="w-100 mw-lg-500px" append-icon="mdi-link" @click:append="window.open(me.website, '_blank')" />
                                    </myinfo-modify-row>
                                </template>

                                <myinfo-modify-row label="연락처" pointer>
                                    <div class="mw-lg-500px">
                                        <v-row class="row--x-small" align="center">
                                            <v-col>
                                                <v-select v-model="me.phone1" :items="['010', '011', '016', '017', '019']" outlined hide-details></v-select>
                                            </v-col>
                                            <v-col cols="auto">-</v-col>
                                            <v-col>
                                                <v-text-field v-model="me.phone2" maxlength="4" outlined hide-details @input="me.phone2 = me.phone2.replace(/[^0-9]/g, '')" />
                                            </v-col>
                                            <v-col cols="auto">-</v-col>
                                            <v-col>
                                                <v-text-field v-model="me.phone3" maxlength="4" outlined hide-details @input="me.phone2 = me.phone2.replace(/[^0-9]/g, '')" />
                                            </v-col>
                                        </v-row>
                                    </div>
                                </myinfo-modify-row>

                                <myinfo-modify-row label="이메일" pointer>
                                    <v-text-field v-model="me.email" type="text" outlined hide-details class="w-100 mw-lg-500px" />
                                </myinfo-modify-row>

                                <myinfo-modify-row label="주소" pointer>
                                    <div class="mw-lg-500px">
                                        <v-row class="row--x-small" align="center">
                                            <v-col cols="9">
                                                <v-text-field v-model="me.postcode" type="text" readonly placeholder="우편번호" outlined hide-details @click="$refs.daumPostcode.open()" />
                                            </v-col>
                                            <v-col cols="3">
                                                <v-btn @click="$refs.daumPostcode.open()" tile color="primary" class="w-100 v-btn--input">검색</v-btn>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field v-model="me.address1" type="text" readonly placeholder="기본주소" outlined hide-details @click="$refs.daumPostcode.open()" />
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field v-model="me.address2" type="text" placeholder="상세주소" outlined hide-details />
                                            </v-col>
                                        </v-row>
                                    </div>
                                </myinfo-modify-row>

                                <template v-if="me.type == COMPANY.value">
                                    <myinfo-modify-row label="담당자 이름" pointer>
                                        <v-text-field v-model="me.name" type="text" outlined hide-details class="w-100 mw-lg-500px" />
                                    </myinfo-modify-row>
                                    <myinfo-modify-row label="담당자 연락처" pointer>
                                        <div class="mw-lg-500px">
                                            <v-row class="row--x-small" align="center">
                                                <v-col>
                                                    <v-select v-model="me.workerPhone1" :items="['010', '011', '016', '017', '019']" outlined hide-details></v-select>
                                                </v-col>
                                                <v-col cols="auto">-</v-col>
                                                <v-col>
                                                    <v-text-field v-model="me.workerPhone2" maxlength="4" outlined hide-details @input="me.workerPhone2 = me.workerPhone2.replace(/[^0-9]/g, '')" />
                                                </v-col>
                                                <v-col cols="auto">-</v-col>
                                                <v-col>
                                                    <v-text-field v-model="me.workerPhone3" maxlength="4" outlined hide-details @input="me.workerPhone2 = me.workerPhone2.replace(/[^0-9]/g, '')" />
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </myinfo-modify-row>
                                    <myinfo-modify-row label="담당자 이메일" pointer>
                                        <v-text-field v-model="me.workerEmail" type="text" outlined hide-details class="w-100 mw-lg-500px" />
                                    </myinfo-modify-row>
                                </template>

                                <myinfo-modify-row label="정보수신방법" pointer>
                                    <v-row v-if="me?.notify" align="center" class="row--small">
                                        <v-col v-for="(item, index) in me?.notify" :key="index" cols="auto">
                                            <div class="d-flex flex-wrap align-center">
                                                <v-checkbox v-model="item.enabled" :label="getNotifyName(item)" hide-details class="d-inline-flex"/>
                                                <template v-if="item.enabled">
                                                    <v-text-field v-model="item.contact" placeholder="연락처" outlined hide-details class="ml-8" />
                                                </template>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </myinfo-modify-row>
                            </div>

                            <!-- 하단버튼 -->
                            <div class="mt-30 mt-md-50">
                                <div class="v-btn--group v-btn--group--large">
                                    <v-btn x-large outlined color="grey-cb" class="w-100 mw-220px" @click="goView()"><span class="primary--text">취소</span></v-btn>
                                    <v-btn x-large color="primary" class="w-100 mw-220px" @click="save">저장</v-btn>
                                </div>
                            </div>
                        </v-tab-item>
                    </v-tabs-items>
                </div>
            </div>
        </v-container>

        <daum-postcode ref="daumPostcode" @change="({ postcode, address }) => Object.assign(me, { postcode, address1: address })"></daum-postcode>
    </client-page>
</template>

<script>
import CryptoAES from "@/plugins/crypto-aes";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import MyinfoRow from "@/components/client/ko/mypage/myinfo-row.vue";
import MyinfoModifyRow from "@/components/client/ko/mypage/myinfo-modify-row.vue";
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import MypageNavigation from "@/components/client/ko/mypage-navigation.vue";

import api from "@/api";
import { USER_NOTIFY_METHODS, USER_TYPES } from "@/assets/variables";
const { PERSON, COMPANY } = USER_TYPES;

export default {
    components: {
        SubVisual,
        MyinfoRow,
        MyinfoModifyRow,
        ClientPage,
        DaumPostcode,
        MypageNavigation,
    },
    props: {
        tab: { type: String, default: "view" },
    },
    data() {
        return {
            me: null,
            categories: [],

            window,
            PERSON,
            COMPANY,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                if (!this.accessToken) {
                    this.$router.push({
                        path: "/login",
                        params: this.$router.params,
                    });
                    return;
                }

                var { user } = await api.v1.me.get();
                var [phone1, phone2, phone3] = (user.phone || "").phoneNumberFormat().split("-");
                var [workerPhone1, workerPhone2, workerPhone3] = (user.workerPhone || "").phoneNumberFormat().split("-");
                if (user?.bornAt) user.bornAt = user.bornAt.toDate();
                if (user?.foundAt) user.foundAt = user.foundAt.toDate();

                this.me = {
                    ...user,
                    phone1,
                    phone2,
                    phone3,
                    workerPhone1,
                    workerPhone2,
                    workerPhone3,
                };

                let { categories } = await api.v1.shop.categories.gets({
                    params: { depth: 1 },
                });
                this.categories = categories;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        checkPassword(password) {
            var checkSpecial = /[~!@#$%^&*()_+|<>?:{}]/;
            var checkEng = /[a-zA-Z]/;
            var checkNum = /[0-9]/;

            if (!checkSpecial.test(password)) throw new Error("비밀번호에 특수문자가 포함되어있어야합니다.");
            if (!checkEng.test(password)) throw new Error("비밀번호에 영문이 포함되어있어야합니다.");
            if (!checkNum.test(password)) throw new Error("비밀번호에 숫자가 포함되어있어야합니다.");
            if (password.length < 8 || 16 < password.length) throw new Error("비밀번호는 8~16자까지입니다.");
        },

        validate() {
            try {
                if ((this.me.subPassword || this.me.subPassword2) && this.me.subPassword != this.me.subPassword2) throw new Error("비밀번호 및 비밀번호확인이 일치하지 않습니다");
                if (this.me.subPassword && this.me.subPassword2) this.checkPassword(this.me.subPassword);

                return true;
            } catch (error) {
                alert(error.message);
            }
            return false;
        },

        async save() {
            if (this.validate()) {
                await api.v1.me.put({
                    ...this.me,
                    subPassword: this.me.subPassword ? CryptoAES.encrypt(this.me.subPassword) : undefined,
                    subPassword2: undefined,
                });

                alert("수정되었습니다");

                this.init();
                this.goView();
            }
        },

        goTop() {
            window.scrollTo({ top: 400, behavior: "smooth" });
        },
        goModify() {
            this.goTop();
            this.$router.push("/mypage/myinfo/modify");
        },
        goView() {
            this.goTop();
            this.$router.push("/mypage/myinfo/view");
        },
        getNotifyName({ method }) {
            return Object.values(USER_NOTIFY_METHODS).find(({ value }) => value == method)?.text;
        },
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
        phone() {
            return this.phone1 && this.phone2 && this.phone3 ? [this.phone1, this.phone2, this.phone3].join("-") : undefined;
        },
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
    },
    watch: {
        "me.phone1"() {
            var { phone1, phone2, phone3 } = this.me;
            this.me.phone = [phone1, phone2, phone3].join("-");
        },
        "me.phone2"() {
            var { phone1, phone2, phone3 } = this.me;
            this.me.phone = [phone1, phone2, phone3].join("-");
        },
        "me.phone3"() {
            var { phone1, phone2, phone3 } = this.me;
            this.me.phone = [phone1, phone2, phone3].join("-");
        },
        "me.workerPhone1"() {
            var { workerPhone1, workerPhone2, workerPhone3 } = this.me;
            this.me.workerPhone = [workerPhone1, workerPhone2, workerPhone3].join("-");
        },
        "me.workerPhone2"() {
            var { workerPhone1, workerPhone2, workerPhone3 } = this.me;
            this.me.workerPhone = [workerPhone1, workerPhone2, workerPhone3].join("-");
        },
        "me.workerPhone3"() {
            var { workerPhone1, workerPhone2, workerPhone3 } = this.me;
            this.me.workerPhone = [workerPhone1, workerPhone2, workerPhone3].join("-");
        },
    },
};
</script>
